import { useMutation, gql } from "@apollo/client";
import { CartItemFragment } from "../components/cart/CartItem";

const RemoveCartItemMutation = gql`
  mutation RemoveCartItem($itemId: ID!) {
    removeCartItem(itemId: $itemId) {
      ...CartItemFragment
    }
  }
  ${CartItemFragment}
`;

const useRemoveCartItem = () => {
  const [removeCartItemMutation] = useMutation(RemoveCartItemMutation);

  const removeCartItem = async (itemId: string) => {
    await removeCartItemMutation({
      variables: { itemId },
      refetchQueries: ["ClientCart"],
    });
  };

  return {
    removeCartItem,
  };
};

export default useRemoveCartItem;
